import cn from 'classnames'

const BulkFooterItem = ({ children }) => {
    return <div className={cn('flex m-2')}>{children}</div>
}

export default BulkFooterItem
